import React from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "../components/layout";
import About from "../components/pages/About";
import Blog from "../components/pages/Blogs";
import SingleBlog from "../components/pages/Blogs/SingleBlog";
import Contact from "../components/pages/Contact";
import Error from "../components/pages/error/Error";
import Home from "../components/pages/Home";
import Login from "../components/pages/login/Login";
import Portfolio from "../components/pages/Portfolio/index";
import SinglePort from "../components/pages/Portfolio/SinglePort";
import Skill from "../components/pages/Skill";
import Protected from "../Dashboard/components/Protected";
import DashLayout from "../Dashboard/layout/DashLayout";
import AllBlog from "../Dashboard/pages/all-blog/AllBlog";
import AllPortfolio from "../Dashboard/pages/all-portfolio/AllPortfolio";
import CreateBlog from "../Dashboard/pages/create-blog/CreateBlog";
import CreatePortfolio from "../Dashboard/pages/create-portfolio/CreatePortfolio";
import Dashboard from "../Dashboard/pages/dashboard/Dashboard";
import EditBlog from "../Dashboard/pages/edit-blog/EditBlog";
import EditPortfolio from "../Dashboard/pages/edit-portfolio/EditPortfolio";
import Users from "../Dashboard/pages/users/Users";

const Routers = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/skill" element={<Skill />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<SinglePort />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<SingleBlog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<DashLayout />}>
          <Route index element={<Protected Cmp={Dashboard} />} />
          <Route
            path="/dashboard/all_posts"
            element={<Protected Cmp={AllBlog} />}
          />
          <Route
            path="/dashboard/create_post"
            element={<Protected Cmp={CreateBlog} />}
          />
          <Route
            path="/dashboard/edit_post"
            element={<Protected Cmp={EditBlog} />}
          />
          <Route
            path="/dashboard/all_portfolio"
            element={<Protected Cmp={AllPortfolio} />}
          />
          <Route
            path="/dashboard/create_portfolio"
            element={<Protected Cmp={CreatePortfolio} />}
          />
          <Route
            path="/dashboard/edit_portfolio"
            element={<Protected Cmp={EditPortfolio} />}
          />
          <Route path="/dashboard/users" element={<Protected Cmp={Users} />} />
        </Route>
      </Routes>
    </div>
  );
};

export default Routers;
